import Vue from "vue";
import VueRouter from "vue-router";
// Auth
import Locked from "./views/auth/Locked";
import OTPCode from "./views/auth/OTPCode";
import OTPNumber from "./views/auth/OTPNumber";
import Reset from "./views/auth/Reset";
import Signin from "./views/auth/Signin";
import Signup from "./views/auth/Signup";
// Dashboard
import Accounts from "./views/dashboards/Accounts";
import AddBankAccount from "./views/dashboards/AddBankAccount";
import AddDebitCard from "./views/dashboards/AddDebitCard";
import BuySell from "./views/dashboards/BuySell";
import History from "./views/dashboards/History";
import IDVerified from "./views/dashboards/IDVerified";
import IDVerifying from "./views/dashboards/IDVerifying";
import Index from "./views/dashboards/Index";
import Recommendation from "./views/dashboards/Recommendation";
// Settings
import EditProfile from "./views/dashboards/settings/EditProfile";
import LinkedAccount from "./views/dashboards/settings/LinkedAccount";
import Preferences from "./views/dashboards/settings/Preferences";
import Security from "./views/dashboards/settings/Security";
import Success from "./views/dashboards/Success";
import UploadID from "./views/dashboards/UploadID";
import VerifyID from "./views/dashboards/VerifyID";
// Demo
import Demo from "./views/Demo";
Vue.use(VueRouter);

const routes = [
  // Demo
  {
    path: "/demo",
    name: "Demo",
    component: Demo,
  },
  // Auth
  {
    path: "/lock",
    name: "Lock",
    component: Locked,
  },
  {
    path: "/otp-1",
    name: "OTPNumber",
    component: OTPNumber,
  },
  {
    path: "/otp-2",
    name: "OTPCode",
    component: OTPCode,
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup,
  },
  {
    path: "/signin",
    name: "Signin",
    component: Signin,
  },
  {
    path: "/reset",
    name: "Reset",
    component: Reset,
  },
  //Dashboard
  {
    path: "/",
    name: "Index",
    component: Index,
  },
  {
    path: "/buy-sell",
    name: "BuySell",
    component: BuySell,
  },
  {
    path: "/accounts",
    name: "Accounts",
    component: Accounts,
  },
  {
    path: "/history",
    name: "History",
    component: History,
  },
  {
    path: "/add-bank-acc",
    name: "AddBankAccount",
    component: AddBankAccount,
  },
  {
    path: "/add-debit-card",
    name: "AddDebitCard",
    component: AddDebitCard,
  },
  {
    path: "/verify-step-1",
    name: "VerifyID",
    component: VerifyID,
  },
  {
    path: "/verify-step-2",
    name: "UploadID",
    component: UploadID,
  },
  {
    path: "/verify-step-3",
    name: "IDVerifying",
    component: IDVerifying,
  },
  {
    path: "/verify-step-4",
    name: "IDVerified",
    component: IDVerified,
  },
  {
    path: "/verify-step-5",
    name: "Recommendation",
    component: Recommendation,
  },
  {
    path: "/verify-step-6",
    name: "Success",
    component: Success,
  },
  // Settings
  {
    path: "/settings-preferences",
    name: "Preferences",
    component: Preferences,
  },
  {
    path: "/settings-account",
    name: "LinkedAccount",
    component: LinkedAccount,
  },
  {
    path: "/settings-security",
    name: "Security",
    component: Security,
  },
  {
    path: "/settings",
    name: "EditProfile",
    component: EditProfile,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
